import axios from "@/libs/axios";
import { ref } from "@vue/composition-api";

export default function useContactMetadata() {
    const metadataColumnNames = ref([]);
    const contactColumnNames = ref([
        "contact.name",
        "contact.email",
        "contact.phone",
        "contact.street",
        "contact.houseNumber",
        "contact.zipCode",
        "contact.city",
        "contact.province",
        "contact.reference",
        "contact.company",
        "contact.jobTitle",
    ]);

    axios
        .get("contacts/metadata", {
            params: {
                fields: "name",
                distinct: "true",
                sort: "name,ASC",
            },
        })
        .then((response) => {
            const metadataStrings = response.data.map((metadata) => `contact.${metadata.name}`);
            metadataColumnNames.value = metadataStrings;
            contactColumnNames.value.push(...metadataStrings);
        });

    return {
        metadataColumnNames,
        contactColumnNames,
    };
}
